export default __webpack_public_path__ + "static/media/bitterl-koenig-rechtsanwalt-immobilienrecht.056d4cb4.svg";